import { PluginRoute } from './plugin-route.interface';
import { Route } from '@angular/router';

export type RouteOperationDelegate = (route: PluginRoute, parent: Route) => void;
